<template>
  <div>
    <el-card class="box-card box-cards" shadow="never">
      <el-row>
        <el-form :inline="true" class="user-search">
          <el-col :span="24">
            <el-form-item>
              <div class="card_top"><span>兑换码管理</span></div>
            </el-form-item>
            <el-form-item>
              <el-select v-model="formInline.params.status" @change="reloadlist">
                <el-option :value="0" label="未使用">未使用</el-option>
                <el-option :value="1" label="已使用">已使用</el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" plain @click="handleEdit()">批量生成
              </el-button>

              <el-button size="small" type="warning" plain @click="handleDownload()">批量下载
              </el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </el-card>
    <el-card class="box-card box-cards2" shadow="never">
      <!--列表-->
      <el-table border ref="multipleTable" :data="tableData" :header-cell-style="headStyle" tooltip-effect="dark"
        style="width: 100%; " v-loading="loading">
        <el-table-column prop="id" label="ID" align="center" width="120"></el-table-column>
        <el-table-column prop="redeemCode" label="兑换码" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.downloadAt" @click="showCode(scope.row)"> 已下载(点击显示)</div>
            <div v-if="!scope.row.downloadAt || showCodes.indexOf(scope.row.id) > -1"> {{ scope.row.redeemCode }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="兑换码状态" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.status == 0"> 未使用</div>
            <div v-if="scope.row.status == 1"> 已使用</div>
          </template>
        </el-table-column>
        <el-table-column prop="user_id" label="使用人" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.user_id">{{ scope.row.user_id }}</div>
            <div v-else> -</div>
          </template>
        </el-table-column>
        <el-table-column prop="jtime" label="创建时间" align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.createdAt | timestampToTime }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="jtime" label="更新时间" align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.updatedAt | timestampToTime }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="jtime" label="操作" align="center">
          <template slot-scope="scope">
            <el-button @click="showQrcode(scope.row)" size="small">小程序码</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </el-card>
    <el-dialog title="批量生成兑换码" :visible.sync="editFormVisible" width="30%">
      <el-form :model="form">
        <el-form-item label="随机生成数量">
          <el-input v-model="form.params.count" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="editFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('editForm')">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="批量下载小程序码" :visible.sync="downloadVisible" width="30%">
      <el-form :model="form">
        <el-form-item label="下载数量">
          <el-input v-model="downloadCount" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="是否新生成">
          <el-switch v-model="downloadType" active-text="生成新的" inactive-text="下载未使用的">
          </el-switch>
        </el-form-item>
        <div v-if="downloadUrl">
          下载地址: <a :href="downloadUrl" target="_blank">{{ downloadUrl }}</a>
        </div>
        <el-form-item>
          <el-button @click="downloadVisible = false">取 消</el-button>
          <el-button type="primary" @click="downloadRedeemCode()" :loading="downloading">导出Excel</el-button>
          <el-button type="primary" @click="downloadQrcode()" :loading="downloading">导出小程序码</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="查看小程序码" :visible.sync="dialogVisible" width="500px">
      <div v-loading="loading">
        <div style="width: 430px;height: 430px;margin:0 auto">
          <img v-if="dialogImageUrl" :src="dialogImageUrl" style="width: 100%;height: 100%;" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import Pagination from "../../components/Pagination";
import debounce from "../../utils/debounce";
import { codelist, generate, codedownload, codeexport } from "../../api/userMG";
import Vue from "vue";

export default {
  data() {
    return {
      title: "编辑信息",

      editFormVisible: false,
      //分页
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      tableData: [], //表格数据 
      showCodes: [],
      formInline: {
        data: {},
        params: {
          pageNum: 1,
          pageSize: 10,
          bookId: 0,
          status: ""
        },
      },
      downloadVisible: false,
      downloadCount: 10,
      downloadType: 0,
      downloading: false,
      downloadUrl: '',
      dialogImageUrl: '',
      dialogVisible: false,
      form: {
        "params": {
          "bookId": 0,
          "count": ""
        },
      },
      //规则验证
      rules: {},
    };
  },
  components: {
    Pagination
  },
  created() {
    this.formInline.params.bookId = this.$route.query.id;
    //数据列表
    this.getlist(this.formInline);
  },
  methods: {
    headStyle() {
      return {
        background: "#A1BBFF",
        color: "#fff",
        letterSpacing: "2px",
        border: " 1px solid #A1BBFF",
        textAlign: "center",
        height: "39px",
      };
    },
    reloadlist() {
      this.getlist(this.formInline)
    },
    //显示数据
    getlist(parameter) {
      this.loading = true;
      codelist(parameter)
        .then((res) => {
          this.loading = false;
          // console.log("userlist", res);
          if (res.code != 200) {
            this.$message({
              type: "info",
              message: res.message,
            });
          } else {
            this.tableData = res.data.records;
            // 分页赋值
            this.pageparm.currentPage = this.formInline.params.pageNum;
            this.pageparm.pageSize = this.formInline.params.pageSize;
            this.pageparm.total = res.data.total;
            // console.log(this.tableData)

            this.showCodes = []
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("加载失败，请稍后再试！");
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.params.pageNum = parm.currentPage;
      this.formInline.params.pageSize = parm.pageSize;
      this.getlist(this.formInline);
    },
    // 搜索事件
    search() {
      this.formInline.params.pageNum = 1;
      this.getlist(this.formInline); //显示
    },
    handleEdit() {
      this.form = {
        "params": {
          "bookId": this.$route.query.id,
          "count": ""
        },
      }
      this.editFormVisible = true
    },
    showCode(row) {
      var idx = this.showCodes.indexOf(row.id)
      if (idx > -1) {
        this.showCodes.splice(idx, 1)
      } else {
        this.showCodes.push(row.id)
      }
    },
    showQrcode(row) {
      this.dialogImageUrl = row.qrcodeUrl
      if (!row.qrcodeUrl) {
        codedownload({
          params: { id: row.id }
        }).then((res) => {
          if (res.code == 200) {
            row.qrcodeUrl = res.data
            this.dialogImageUrl = res.data
          } else {
            this.dialogVisible = false
            this.$message({
              message: res.message || "二维码获取失败！",
              type: "error",
            });
          }
        }).catch(() => {
          this.dialogVisible = false
        })
      }
      this.dialogVisible = true
    },
    handleDownload() {
      this.downloadVisible = true
    },
    downloadRedeemCode() {
      this.downloading = true
      codeexport({
        params: {
          count: this.downloadCount,
          bookId: this.formInline.params.bookId,
          downloadNew: this.downloadType ? 1 : 0
        }
      }).then((res) => {
        if (res.code == 200) {
          this.downloadUrl = res.data
        } else {
          this.$message({
            message: res.message || "兑换码导出失败！",
            type: "error",
          });
        }
        this.downloading = false
      }).catch(() => {
        this.downloading = false
      })
    },
    downloadQrcode() {
      this.downloading = true
      codedownload({
        params: {
          count: this.downloadCount,
          bookId: this.formInline.params.bookId,
          downloadNew: this.downloadType ? 1 : 0
        }
      }).then((res) => {
        if (res.code == 200) {
          this.downloadUrl = res.data
        } else {
          this.$message({
            message: res.message || "二维码下载失败！",
            type: "error",
          });
        }
        this.downloading = false
      }).catch(() => {
        this.downloading = false
      })
    },
    submitForm(info) {

      debounce(() => {

        generate(this.form)
          .then(res => {
            if (res.code == 200) {
              this.editFormVisible = false;
              this.getlist(this.formInline);
              this.$message({
                message: "生成成功！",
                type: "success",
              });
            } else {
              this.$message({
                type: "info",
                message: res.message,
              });
            }
          })
          .catch((err) => {
            this.editFormVisible = false;
            this.$message.error("保存失败，请稍后再试！");
          });

      }, 1500);
    },




  },
};
</script>
<style>
@import "../../assets/css/index.css";

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.divBox {
  /*flex-direction: row;*/
  float: left;
  position: relative;
  margin-right: 10px;
}

.imgSty {
  margin-left: 3px;
}

.delIcon {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 20px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 145px;
  height: 145px;
  line-height: 145px;
  text-align: center;
}

.avatar {
  width: 145px;
  height: 145px;
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/views/book/daily.vue